module.exports = __webpack_public_path__ + "img/4bg.dbd12874.png";